import type { DataType } from '../data';

export const enum OperationType {
    API = 'api',
    Undo = 'undo',
    Redo = 'redo',
    BeginTransaction = 'begin-transaction',
    EndTransaction = 'end-transaction',
    EnqueueMutations = 'enqueue-mutations',
}

export type IOperationRecordMap = {
    [OperationType.API]: {
        type: OperationType.API;
        model: {
            id: string;
            type: DataType;
        };
        api: string;
        args: unknown[];
        beginAt: number;
        endAt?: number;
    };
    [OperationType.Undo]: {
        type: OperationType.Undo;
        beginAt: number;
        endAt?: number;
    };
    [OperationType.Redo]: {
        type: OperationType.Redo;
        beginAt: number;
        endAt?: number;
    };
    [OperationType.BeginTransaction]: {
        type: OperationType.BeginTransaction;
        beginAt: number;
        endAt?: number;
    };
    [OperationType.EndTransaction]: {
        type: OperationType.EndTransaction;
        endAt?: number;
    };
    [OperationType.EnqueueMutations]: {
        type: OperationType.EnqueueMutations;
        mutations: unknown[];
        source: unknown;
        beginAt: number;
        endAt?: number;
    };
};

export type IOperationRecord = IOperationRecordMap[OperationType];
